var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      ref: "menu",
      attrs: {
        bottom: "",
        left: "",
        "offset-y": "",
        "close-on-content-click": false,
        "z-index": 99999,
        transition: "fade-transition",
        "min-width": "300",
        "max-width": "340",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    { attrs: { icon: "", title: "Filter options" } },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _c(
                    "v-badge",
                    {
                      attrs: {
                        value: _vm.activeCount > 0,
                        content: _vm.activeCount,
                        color: _vm.color,
                        overlap: "",
                      },
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            color: _vm.activeCount > 0 ? _vm.color : undefined,
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.activeCount > 0
                                  ? _vm.$MDI.Filter
                                  : _vm.$MDI.FilterOutline
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "filter-menu-card" },
        [
          _c(
            "v-expansion-panels",
            { attrs: { accordion: "", flat: "" } },
            _vm._l(_vm.columns, function (column) {
              return _c(
                "v-expansion-panel",
                { key: column.key },
                [
                  _c("v-expansion-panel-header", { staticClass: "py-2" }, [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex align-center",
                        staticStyle: { "min-width": "0" },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "text-body-2 flex-shrink-0" },
                          [_vm._v(_vm._s(column.label))]
                        ),
                        _vm._v(" "),
                        column.summary
                          ? _c(
                              "span",
                              {
                                staticClass: "text-caption ml-2 text-truncate",
                                style: { color: _vm.color },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(column.summary) +
                                    "\n                        "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    [
                      _c(
                        "ResultFilterField",
                        _vm._b(
                          {
                            on: {
                              filter: (v) => _vm.$emit("filter", column.key, v),
                            },
                          },
                          "ResultFilterField",
                          column.field,
                          false
                        )
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
          _vm._v(" "),
          _vm.activeCount > 0
            ? [
                _c("v-divider"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex justify-end pa-2" },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { text: "", small: "" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("clear")
                          },
                        },
                      },
                      [_vm._v("Clear all")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }